export const TestIds = {
  buttonElement: 'buttonElement',
  linkElement: 'linkElement',
} as const;

export enum ElementType {
  Link = 'Link',
  Button = 'Button',
}
